<template>
  <div>
    <section class="course_solo_box">
      <h1 class="course_title">企业数智化AI经营系统方案班</h1>
      <h3 class="course_sub_title">AI 营销系统专场 <span>第一期</span></h3>
      <div class="course_position">
        <img src="../assets/img/courseSoloImg1.png" alt="" />
        <div>
          <h1>课程核心定位</h1>
          <span></span>
          <p>
            由阿里巴巴与钉钉联合推出，聚焦企业数智化 AI 营销落地，以
            “长见识、升思维、出方案、建系统” 为核心目标，主打
            “给我一个销冠，还你 100 个销冠”，通过 3 天线下集训 + 3
            个月线上陪成，打造可复制的企业 AI 营销实战体系。
          </p>
        </div>
      </div>

      <!-- 课程目的 -->
      <div class="course_purpose">
        <h1>课程目的</h1>
        <ul class="course_purpose_list">
          <li>
            <img src="../assets/img/courseSoloIcon1.png" alt="" />
            <h4>成人才</h4>
            <p>锻造懂客户、有信仰、会用 AI 的复合型数字化营销管理人才</p>
          </li>
          <li>
            <img src="../assets/img/courseSoloIcon2.png" alt="" />
            <h4>成方案</h4>
            <p>输出可直接落地、标准化的 AI 营销获客方案</p>
          </li>
          <li>
            <img src="../assets/img/courseSoloIcon3.png" alt="" />
            <h4>成系统</h4>
            <p>搭建全链路、可闭环、可迭代的企业 AI 营销体系</p>
          </li>
          <li>
            <img src="../assets/img/courseSoloIcon4.png" alt="" />
            <h4>成利润</h4>
            <p>降本增效、复制销冠，实现业绩与利润倍增</p>
          </li>
        </ul>
      </div>
      <!-- 课程核心价值 -->
      <div class="course_core">
        <h1>课程核心价值</h1>
        <ul class="core_content">
          <li v-for="(item, index) in coreCoreList" :key="index">
            <img :src="item.img" alt="" />
            <div>
              <h3>{{ item.title }}</h3>
              <p v-for="(citem, cindex) in item.content" :key="cindex">
                {{ citem }}
              </p>
            </div>
          </li>
        </ul>
      </div>

      <!-- 课程安排 -->
      <div class="course_arrange">
        <h1>课程安排</h1>
        <div class="arrange_img">
          <img src="../assets/img/courseImg.png" alt="" />
        </div>
      </div>
      <div class="apply_btn" @click="$utils.goPage('/applyCourse')">
        申请课程
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "CourseSolo",
  data() {
    return {
      coreCoreList: [
        {
          id: 1,
          img: "",
          title: "企业营销文化建设",
          content: [
            "学习阿里 “六脉神剑” 文化，确立客户第一的底层逻辑",
            "传承中供铁军极致执行力、结果导向的销售基因",
            "建立 AI + 数据驱动的实战打赢文化",
          ],
        },
        {
          id: 2,
          img: "",
          title: "提升团队营销市场力",
          content: [
            "系统化 AI 技能培训，打造专业 AI 营销团队",
            "自动化替代重复工作，提升人效与资源配置",
            "数据驱动决策，实现精准获客与转化",
            "建立长效 AI 思维赋能体系",
          ],
        },
        {
          id: 3,
          img: "",
          title: "打造市场击穿力",
          content: [
            "掌握前沿 AI 大模型，实现营销降维打击",
            "聚焦企业实战场景，挖掘新增量路径",
            "复制标杆成功模式，快速落地见效",
          ],
        },
        {
          id: 4,
          img: "",
          title: "全员经验萃取与平台沉淀",
          content: [
            "把个人隐性经验转为企业显性 AI 中台资产",
            "激活全员价值，实现个人与平台双向赋能",
            "构建自驱型增长飞轮，形成组织核心竞争力",
          ],
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.coreCoreList = this.coreCoreList.map((item, index) => {
      item.img = this.$utils.formatImgUrl(
        `/homeBarrageImg/courseSoloImg${index + 1}.png`,
      );
      return item;
    });
  },
  methods: {},
};
</script>

<style scoped lang="less">
.course_title {
  font-size: 2rem;
  font-weight: bold;
  color: #000;
}
.course_sub_title {
  font-size: 1.125rem;
  font-weight: 400;
  color: #000;
  margin: 2rem auto 4rem;

  > span {
    color: rgba(117, 117, 117, 1);
    margin-left: 0.625rem;
  }
}
.course_position {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.25);
  padding: 2.5rem;
  box-sizing: border-box;

  > img {
    width: 40%;
  }
  > div {
    width: 52%;
    text-align: left;

    > h1 {
      font-size: 2rem;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      letter-spacing: 2px;
    }
    > span {
      width: 2rem;
      height: 6px;
      opacity: 1;
      background: rgba(1, 195, 221, 1);
      display: block;
      margin: 0.625rem 0 2rem;
    }
    > p {
      width: 100%;
      opacity: 1;
      font-size: 1rem;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      text-align: left;
      line-height: 1.6rem;
      letter-spacing: 1px;
    }
  }
}

.course_purpose,
.course_core,
.course_arrange,
.apply_btn {
  margin-top: 8.75rem;

  > h1 {
    font-size: 2rem;
    font-weight: 400;
    letter-spacing: 1px;
    color: rgba(0, 0, 0, 1);
    margin-bottom: 3.5rem;
  }
}

.course_purpose_list {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;

  > li {
    width: 50%;
    text-align: center;
    margin-top: 5rem;

    > img {
      width: 3rem;
      height: 3rem;
    }
    > h4 {
      font-size: 1.125rem;
      font-weight: 400;
      letter-spacing: 1px;
      color: rgba(0, 0, 0, 1);
      margin: 1.25rem 0 1.875rem;
    }
    > p {
      /** 文本1 */
      font-size: 0.875rem;
      font-weight: 400;
      letter-spacing: 1px;
      line-height: 21px;
      color: rgba(102, 102, 102, 1);
    }
  }
}

.core_content {
  width: 100%;

  > li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 30px rgba(0, 0, 0, 0.1);
    margin-bottom: 2rem;

    > img {
      width: 30%;
    }
    > div {
      width: 64%;
      text-align: left;

      > h3 {
        font-size: 1.5rem;
        font-weight: 400;
        letter-spacing: 1px;
        color: rgba(9, 15, 25, 1);
        margin-bottom: 2rem;
      }
      > p {
        font-size: 1rem;
        font-weight: 400;
        letter-spacing: 1px;
        color: rgba(102, 102, 102, 1);
        margin-top: 1rem;
      }
    }
  }
}

.arrange_img {
  width: 100%;
  opacity: 1;
  > img {
    width: 100%;
  }
}
.apply_btn {
  width: 15rem;
  height: 4rem;
  background: linear-gradient(
    90deg,
    rgba(156, 179, 255, 1) 0%,
    rgba(2, 181, 232, 1) 100%
  );

  font-size: 1.875rem;
  font-weight: 300;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8.75rem auto 0;
  border-radius: 2rem;
  cursor: pointer;
}
</style>
